export { default, AvailabilityTable } from './AvailabilityTable';



// WEBPACK FOOTER //
// ./app/components/shared/AvailabilityTable/index.js